module.exports = __webpack_public_path__ + "static/desktop/img/material-1.0c8749b2.jpg";